import React, { createContext, useEffect, useState, } from 'react';
import { isTokenValid } from '../api/auth.js';

// Create a Context Provider called AuthProvider
export const AuthContext = createContext()

// Create our own Context component in which data about auth lives on its state
export default function AuthContextComponent({children}) {
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [user, setUser] = useState("")

    useEffect(() => {
      const token = localStorage.getItem('token')
      if (token) {
        setIsLoggedIn(true)
      }
    }, [isLoggedIn])

    useEffect(() => {
      const user = localStorage.getItem('user')
      if (user) {
        setUser(user)
      }
    }, [user])

    // Write some logic to onload check if the user is logged in, then set logged in accordingly.
    async function validateToken() {
      try {
        const response = await isTokenValid()
        return {valid: response.valid, username: response.username}
      } catch(error) {
        return {valid: error.response.data.valid, username: ""}
      }
    }

    useEffect(() => {
      validateToken()
      .then((response) => {
        setIsLoggedIn(response.valid);
        setUser(response.username);
      })
      .catch((error) => {
        console.error(error)
      })
     }, [])

    // AuthContext, will simply render the AuthProvider, 
    // and pass its state data into it, so other components can use it.
    return (
        <AuthContext.Provider value={{ isLoggedIn, setIsLoggedIn, user, setUser }}>
          {children}
        </AuthContext.Provider>
      );
      
}